import { Instance, types } from 'mobx-state-tree';

const ClientScheduleLessonTeacher = types
	.model('ClientScheduleLessonTeacher', {
		id: types.identifierNumber,
		zoom_on_off: types.maybeNull(types.number),
		zoom_link: types.maybeNull(types.string),
		first_name: types.optional(types.maybeNull(types.string), ''),
		last_name: types.optional(types.maybeNull(types.string), ''),
	})
	.views((self) => ({
		get fullName() {
			return [self.first_name, self.last_name].join(' ');
		},
	}));

export default ClientScheduleLessonTeacher;

export interface IClientScheduleLessonTeacherModel
	extends Instance<typeof ClientScheduleLessonTeacher> {}
